import { Component } from '@angular/core';
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent { }
